import React, { useEffect } from 'react';
import './NotificationToast.css';

const NotificationToast = ({ message, type = 'error', onClose, duration = 4000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '✕';
    }
  };

  return (
    <div className={`notification-toast notification-toast-${type}`}>
      <div className="notification-toast-icon">
        {getIcon()}
      </div>
      <div className="notification-toast-message">
        {message}
      </div>
      <button
        className="notification-toast-close"
        onClick={onClose}
        aria-label="Cerrar"
      >
        ×
      </button>
    </div>
  );
};

export default NotificationToast;
